<template>
  <!-- page wrapper start -->
  <div class="pg-wrapper homepage">
    <app-header>
      <section
        v-if="access_type == 'internal'"
        slot="header-foot"
        :class=" scrolled > fixAt ? 'search-box-wrapper at-header show' : 'search-box-wrapper at-header'"
      >
        <form @submit.prevent="searchProduct($event)" onSubmit="return false;">
          <div class="field search-box">
            <div class="control">
              <input
                v-model="searchText"
                @keyup.enter="searchProduct($event)"
                class="input"
                type="text"
                placeholder="Search for cannabis products"
              />
              <span class="icon">
                <img src="@/assets/img/icon-search.svg" alt="image" />
              </span>
            </div>
          </div>
        </form>
      </section>
    </app-header>
 

    <main  :class="'content-wrapper ' + (access_type == 'internal' ? '' : 'pb0')">
      
      <!-- <notification></notification> -->
      <banner :class="scrolled > fixAt ? 'hide' : ''"></banner>
   
      <search v-if="access_type == 'internal'" :class="scrolled > fixAt ? 'hide body-search-section' : 'body-search-section'"></search>
      <!-- intro section start-->
      <section
        :class="scrolled > fixAt ? 'intro-section section bg-primary has-text-white fixed-header' : 'bg-primary intro-section section'"
      >
        <div class="container">
          <!-- intro delete button -->
          <div class="has-text-right">
            <!-- <a @click.prevent="closeIntroSection()" href="#" class="btn-close"></a> -->
          </div>

          <div class="columns">
            <div class="column">
              <!-- intro block -->
              <div class="intro-block has-text-centered">
                <img src="@/assets/img/Find_Cannabis_Near_You.svg" alt="image" class="intro-image" />
                <h2 class="title text-white">Find cannabis near you.</h2>
                <p class="text-white">
                  Discover products available at licensed
                  <br />cannabis retailers.
                </p>
              </div>
            </div>
            <div class="column">
              <!-- intro block -->
              <div class="intro-block has-text-centered">
                <img src="@/assets/img/Reserve_and_Pickup.svg" alt="image" class="intro-image" />
                <h2 class="title text-white">Reserve and pick up.</h2>
                <p class="text-white">
                  Reserve your order, skip the line, and pick up
                  <br />products in-store.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <product-categories v-if="access_type == 'internal'" :class="scrolled > fixAt ? 'mt-3' : ''"></product-categories>
      <!-- <recommend-products></recommend-products> -->
      <store-nearby :locationnearby="nearestLocations" v-if="(access_type == 'internal') && nearestLocationStatus"></store-nearby>
    </main>
    <app-footer></app-footer>
  </div>
</template>
<script>
import LocationApis from '@/Components/Controllers/LocationApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import CartApis from '@/Components/Controllers/CartApis';
import Helpers from '@/Components/Helpers/Helpers';
// import Notification from "@/Components/Pages/PageComponents/Homepage/Notification";
import Banner from "@/Components/Pages/PageComponents/Homepage/Banner";
import Search from "@/Components/Pages/PageComponents/Homepage/Search";
import ProductCategories from "@/Components/Pages/PageComponents/Homepage/ProductCategories";
//import RecommendProducts from "@/Components/Pages/PageComponents/Homepage/RecommendProducts";
import StoreNearby from "@/Components/Pages/PageComponents/Homepage/StoreNearby";
import { mapGetters, mapActions } from "vuex";
import Env from '@/env';

export default {
  components: {
    Banner,
    Search,
    ProductCategories,
    StoreNearby
  },
  name: "HomePage",
  data() {
    return {
      access_type: '', 
      headerFixAt: 10,
      fixAt: 0,
      scrolled: 0,
      searchText: "",
      nearestLocationStatus: false,
      nearestLocations: [],
    };
  },

  computed: {
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail", 
      vg_userAddress: "location/userAddress",
      vg_selectedLocation: "location/selected",
    }), 
  },

  async mounted() {
    
    // Fetch on every page load for latest data and check to redirect or not
    const self = this;
    let businessProfileRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);

    // If invalid business slug then pass to base url with will grab default slug from env
    if(businessProfileRes.status != 200){
      self.va_snackbar({
        type: 'warning', 
        message:'Sorry cannot find the business. Redirecting....'
      });
      self.$router.push('/')
    }
    
    // Fetch nearest location from above business ID
    let nearestLocationRes = await LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, false);
    
    if(nearestLocationRes.status == 200){
      this.nearestLocations = nearestLocationRes.data.payload;
      // lets find the the vg_selectedLocation.id on nearest location if found, keep it selected else select the first one
      if(_.isEmpty(this.vg_selectedLocation)){
         // Set the first location as default location
        if(nearestLocationRes.data.payload[0]){
          await self.va_setSelectedLocation(nearestLocationRes.data.payload[0]);
          // Fetch location cart as we are goign to select first location by default
          await CartApis.locationCart(nearestLocationRes.data.payload[0].id, Helpers.getLocationCartFullUrl(self));
        } else {
          // no location found
          self.va_setSelectedLocation({});
        }
      } else {
        let findtheSelectedLocation = _.find(nearestLocationRes.data.payload, { 'id': this.vg_selectedLocation.id });
        // if there is already a selected location present 
        // check the location id is in nearby locaiton or not 
        if(!findtheSelectedLocation){
          // Id do not exist on nearby location, 
          if(nearestLocationRes.data.payload[0]){
            await self.va_setSelectedLocation(nearestLocationRes.data.payload[0]);
            // Fetch location cart as we are goign to select first location by default
            await CartApis.locationCart(nearestLocationRes.data.payload[0].id, Helpers.getLocationCartFullUrl(self));
          } else {
            // no location found
            self.va_setSelectedLocation({});
          }

        }

      }
      
    
      // There is only 1 location redirect to that location
      if(nearestLocationRes.data.payload.length == 1){
        if(Env.businessNotToRedirect.indexOf(self.vg_businessProfile.id) < 0){
          self.$router.push({ 
            name: 'StoreLanding', 
            params: { 
              business_slug: self.$route.params.business_slug, 
              store_slug: nearestLocationRes.data.payload[0].slug
            } 
          });
        } 
      } 
    }
    this.nearestLocationStatus = true; // its fetched

    var headerHeight = document.getElementsByClassName('header');
    var bannerHeight = document.getElementsByClassName('banner');
    this.fixAt = bannerHeight[0].scrollHeight - headerHeight[0].scrollHeight;
    // bus.$emit('show-modal-verified-email', true);
    window.addEventListener("scroll", this.handleScroll);

    if(this.$route.query.access_type){
      this.access_type = this.$route.query.access_type;
    }
  
  },

  methods: {
    handleScroll() {
      this.scrolled = window.scrollY;
    },
    searchProduct() {

      this.$router.push({ 
        name: 'SearchProductResult', 
        params:{
          store_slug: this.vg_selectedLocation.slug,
        },
        query: { ...this.$route.query, ...{product_name: this.searchText.trim() } } 
      })
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    ...mapActions({
      va_setSelectedLocation: "location/setSelected",
      va_snackbar: "snackbar/setSnackbar",
      va_spinner: "spinner/setSpinner",
    })

  }
};
</script>

<style scoped>
section.search-box-wrapper.at-header {
  margin-top: 0px;
  border-top: 1px solid #f5f5f5;
  position: relative;
}
section.search-box-wrapper.at-header .search-box .control .input {
  border-radius: 0px;
}
header.header {
  box-shadow: 0px 3px 5px #ccc;
  position: relative;
  z-index: 5;
}
.search-box-wrapper.at-header {
  overflow: hidden;
  height: 0;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}
.search-box-wrapper.at-header.show {
  height: 53px;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}

.search-box-wrapper.hide {
  height: 0;
  overflow: hidden;
  min-height: 0;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}
.search-box-wrapper {
  height: auto;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}
section.intro-section{
  padding-top: 50px ;
}
section.intro-section.section.fixed-header {
  /* margin-top: 50px; */
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}
section.intro-section.section {
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}

section.search-box-wrapper.at-header.show .search-box .control .input{
  box-shadow: none !important;
}
</style>